import { connect } from 'react-redux'
import AlertModalView from 'support/popup_dialogs/views/components/alert_modal_view/AlertModalView'
import { hideDialog } from 'support/popup_dialogs/modal_alert_controller/ModalActions'
import i18n from 'support/i18n'
import Navigation from 'support/navigation'

const mapStateToProps = (state, ownProps) => ({
  title: 'Successfully!',
  description: ownProps.description,
  mainButtonText: 'Okay',
})

const mapDispatchToProps = dispatch => {
  return {
    mainButtonAction: () => {
      dispatch(hideDialog())
      
      setTimeout(() => {
        window.location.reload();
      }, 0);

    }
   
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AlertModalView)
